import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { AthleteProgramsPage } from "src/pages/AthleteProgramsPage";

const routeSearchSchema = z.object({
  status: z.enum(["active", "completed"]).optional(),
  q: z.string().optional(),
});

export const Route = createFileRoute("/_auth/_athlete/programs/")({
  component: AthleteProgramsPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  shouldReload: false,
  loaderDeps: ({ search }) => search,
  async loader({ deps }) {
    return await loaderHandler(async ({ trpc }) => {
      const status = deps.status;
      const query = deps.q || "";

      const programs = await trpc.athlete.getPrograms.query({
        pageIndex: 0,
        pageSize: 20,
        query,
        ...(status && { status }),
      });

      return {
        data: {
          programs,
        },
      };
    });
  },
});
